var LifeCycleEventName = /* @__PURE__ */ ((LifeCycleEventName2) => {
  LifeCycleEventName2["beforeFetchUserInfo"] = "beforeFetchUserInfo";
  LifeCycleEventName2["afterFetchUserInfo"] = "afterFetchUserInfo";
  LifeCycleEventName2["beforeFetchConsentData"] = "beforeFetchConsentData";
  LifeCycleEventName2["afterFetchConsentData"] = "afterFetchConsentData";
  LifeCycleEventName2["beforeFetchCollectionPoint"] = "beforeFetchCollectionPoint";
  LifeCycleEventName2["afterFetchCollectionPoint"] = "afterFetchCollectionPoint";
  LifeCycleEventName2["beforeFetchEntities"] = "beforeFetchEntities";
  LifeCycleEventName2["afterFetchEntities"] = "afterFetchEntities";
  LifeCycleEventName2["beforeFetchNotificationData"] = "beforeFetchNotificationData";
  LifeCycleEventName2["afterFetchNotificationData"] = "afterFetchNotificationData";
  LifeCycleEventName2["beforeUpdateRecords"] = "beforeUpdateRecords";
  LifeCycleEventName2["afterUpdateRecords"] = "afterUpdateRecords";
  LifeCycleEventName2["beforeNotify"] = "beforeNotify";
  LifeCycleEventName2["afterNotify"] = "afterNotify";
  LifeCycleEventName2["beforeRemoveNotification"] = "beforeRemoveNotification";
  LifeCycleEventName2["afterRemoveNotification"] = "afterRemoveNotification";
  LifeCycleEventName2["beforeThirdPartyApprove"] = "beforeThirdPartyApprove";
  LifeCycleEventName2["afterThirdPartyApprove"] = "afterThirdPartyApprove";
  LifeCycleEventName2["beforeThirdPartyReject"] = "beforeThirdPartyReject";
  LifeCycleEventName2["afterThirdPartyReject"] = "afterThirdPartyReject";
  return LifeCycleEventName2;
})(LifeCycleEventName || {});
var StorageType = /* @__PURE__ */ ((StorageType2) => {
  StorageType2["sessionStorage"] = "sessionStorage";
  StorageType2["localStorage"] = "localStorage";
  StorageType2["inMem"] = "inMem";
  return StorageType2;
})(StorageType || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["INFO"] = "info";
  LogLevel2["WARN"] = "warn";
  LogLevel2["ERROR"] = "error";
  return LogLevel2;
})(LogLevel || {});
var EntityRelation = /* @__PURE__ */ ((EntityRelation2) => {
  EntityRelation2["AND"] = "AND";
  EntityRelation2["OR"] = "OR";
  return EntityRelation2;
})(EntityRelation || {});
var ConsentStatus = /* @__PURE__ */ ((ConsentStatus2) => {
  ConsentStatus2["UNSUPPORTED"] = "Unsupported";
  ConsentStatus2["APPROVE"] = "Approve";
  ConsentStatus2["REJECT"] = "Reject";
  ConsentStatus2["NOT_DETERMINED"] = "NotDetermined";
  ConsentStatus2["PENDING_REVIEW"] = "PENDING_REVIEW";
  ConsentStatus2["REVOKE"] = "REVOKE";
  return ConsentStatus2;
})(ConsentStatus || {});
var ConsentStatusParam = /* @__PURE__ */ ((ConsentStatusParam2) => {
  ConsentStatusParam2[ConsentStatusParam2["UNSUPPORTED"] = 0] = "UNSUPPORTED";
  ConsentStatusParam2[ConsentStatusParam2["APPROVE"] = 1] = "APPROVE";
  ConsentStatusParam2[ConsentStatusParam2["REJECT"] = 2] = "REJECT";
  ConsentStatusParam2[ConsentStatusParam2["NOT_DETERMINED"] = 3] = "NOT_DETERMINED";
  ConsentStatusParam2[ConsentStatusParam2["PENDING_REVIEW"] = 4] = "PENDING_REVIEW";
  ConsentStatusParam2[ConsentStatusParam2["REVOKE"] = 5] = "REVOKE";
  return ConsentStatusParam2;
})(ConsentStatusParam || {});
var StorageName = /* @__PURE__ */ ((StorageName2) => {
  StorageName2["ENTITIES"] = "entities";
  StorageName2["COLLECTION_POINTS"] = "collectionPoints";
  StorageName2["NOTIFICATIONS"] = "notifications";
  return StorageName2;
})(StorageName || {});
const STATUS_MAP = {
  [0 /* UNSUPPORTED */]: "Unsupported" /* UNSUPPORTED */,
  [1 /* APPROVE */]: "Approve" /* APPROVE */,
  [2 /* REJECT */]: "Reject" /* REJECT */,
  [3 /* NOT_DETERMINED */]: "NotDetermined" /* NOT_DETERMINED */,
  [4 /* PENDING_REVIEW */]: "PENDING_REVIEW" /* PENDING_REVIEW */,
  [5 /* REVOKE */]: "REVOKE" /* REVOKE */
};
export {
  ConsentStatus,
  ConsentStatusParam,
  EntityRelation,
  LifeCycleEventName,
  LogLevel,
  STATUS_MAP,
  StorageName,
  StorageType
};
